<template>
  <vs-popup
    title="Search appointment"
    fullscreen
    :active.sync="searchAppointmentConfig.isActive"
    id="search-appointment-popup"
  >
    <div class="mx-auto h-full lg:w-2/3 md:w-full">
      <div class="w-full pb-base">
        <vs-input
          class="w-full search-input"
          @keyup="searchAppointment"
          v-model.lazy="search"
          placeholder="What are you looking for?"
        ></vs-input>
        <p class="search-by-text text-grey-custom mt-3">Search by client name or mobile</p>
        <div class="vs-con-loading__container" id="search-result-content">
          <p class="head-title" v-if="search == ''">Upcoming appointments</p>
          <div v-if="appointment_arr.length > 0" class="search-result">
            <div
              class="con-tab-ejemplo border-bottom-custom leading-tight"
              v-for="(item, index) in appointment_arr"
              :key="index"
              @click="clickAppointment(item)"
            >
              <p
                class="font-bold my-3 text-primary text-lg"
                v-if="showYear[index]"
              >{{getYear(item[0].date)}}</p>
              <div class="flex align-start p-4 pb-0 cursor-pointer appointment-item">
                <div class="pr-6">
                  <p class="font-bold text-2xl pt-0">{{getDayOfMonth(item[0].date)}}</p>
                  <p class="text-grey-custom pt-0 text-xl">{{getMonth(item[0].date)}}</p>
                </div>
                <div>
                  <p class="pt-0 pb-1">
                    <span class="text-grey-custom">{{getDayOfWeek(item[0].date)}} {{item[0].start_time}}</span>
                    <span class="ml-3 text-uppercase" :class="`text-${getStatusColor(item[0].status)}`">{{item[0].status}}</span>
                  </p>
                  <div>
                    <div class="pb-4" v-for="(service, i) in item" :key="i">
                      <p
                        class="font-bold text-lg pt-0"
                        v-if="service.service"
                      >{{service.service.name}}</p>
                      <p class="text-grey-custom mt-1 pt-0">
                        <span v-if="service.duration">{{service.duration.text}}</span>
                        <span v-else>0m</span>
                        with
                        <span
                          v-if="service.employee"
                        >{{service.employee.name}}</span>
                        <span v-else>No staff</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="font-bold ml-auto text-lg"
                >${{parseFloat(item[0].price_final).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
              </div>
            </div>
          </div>
          <div class="content-text text-grey-custom" v-else>None found</div>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import moment from "moment";
export default {
  props: {
    searchAppointmentConfig: {
      type: Object
    }
  },
  created() {
    // let params = {keywords: "test"},
    this.$store.dispatch("appointment/GET_LIST_SEARCH").then(() => {
      this.getData();
    });
  },
  data() {
    return {
      search: "",
      appointment_arr: [],
      showYear: [],
      key: this.$route.query.key ? parseInt(this.$route.query.key) + 1 : 0
    };
  },
  watch: {
    searchAppointmentConfig: {
      immediate: true,
      deep: true,
      handler() {
        if (this.searchAppointmentConfig.isActive) {
          document.body.classList.add("overflow-hidden");
          this.search = '';
          this.searchAppointment();
        } else {
          document.body.classList.remove("overflow-hidden");
        }
      }
    }
  },
  computed: {
    appointmentList() {
      // console.log(this.$store.getters["appointment/searchList"]);
      return this.$store.getters["appointment/searchList"];
    }
  },
  methods: {
    getValidTime(date) {
      let day = date;
      if (date && date.includes("at")) {
        day = date.replace("at", "");
      }
      return day;
    },
    getDayOfWeek(date) {
      let day = this.getValidTime(date);
      return moment(day).format("ddd");
    },
    getDayOfMonth(date) {
      let day = this.getValidTime(date);
      return moment(day).format("DD");
    },
    getYear(date) {
      let day = this.getValidTime(date);
      return moment(day).format("YYYY");
    },
    getMonth(date) {
      let day = this.getValidTime(date);
      return moment(day).format("MMM");
    },
    getData() {
      let appointmentList = this.$store.getters["appointment/searchList"].items;
      this.appointment_arr = [];
      for (let i = 0; i < appointmentList.length; i++) {
        let item = appointmentList[i];
        let arr_item = [];
        arr_item.push(item);
        if (
          item.additional_appointments &&
          item.additional_appointments.length > 0
        ) {
          for (let j = 0; j < item.additional_appointments.length; j++) {
            arr_item.push(item.additional_appointments[j]);
          }
        }
        this.appointment_arr.push(arr_item);
      }
      this.getShowYear();
      // console.log(this.appointment_arr);
    },
    getStatusColor(status) {
      if (status == null) {
        return "primary";
      }
      status = status.toLowerCase();
      if (status == "scheduled" || status == "completed") {
        return "success";
      } else if (status == "cancel" || status == "pending") {
        return "danger";
      } else {
        return "primary";
      }
    },
    getShowYear() {
      this.showYear = [];
      // let curYear = moment(new Date()).format('YYYY');
      // let curYear = moment().format("YYYY");
      let curYear = 0;
      let prev_year = curYear;
      let arr_appointment = this.$store.getters["appointment/searchList"].items;
      // console.log(arr_appointment)

      for (let i = 0; i < arr_appointment.length; i++) {
          let year = this.getYear(arr_appointment[i].date);
          if (year == curYear) {
              this.showYear.push(false);
          } else if (year != prev_year) {
              prev_year = year;
              this.showYear.push(true);
          } else {
              this.showYear.push(false);
          }
      }
    },
    searchAppointment() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.$vs.loading({
        container: "#search-result-content",
        scale: 0.8
      });
      this.timer = setTimeout(() => {
        const obj = {
          keywords: this.search
        };
        this.$store.dispatch("appointment/GET_LIST_SEARCH", obj).then(() => {
          this.getData();
          this.$vs.loading.close("#search-result-content > .con-vs-loading");
        });
      }, 500);
    },
    clickAppointment(appointment) {
      this.$router.push(
        {
          name: "appointment",
          query: { key: this.key++ },
          params: { id: appointment[0].id }
        },
        () => {
          this.searchAppointmentConfig.isActive = false;
        }
      );
    },
  }
};
</script>